import React from "react";
import {
  HeaderConfig,
  IntroContentConfig,
  IntroThemeConfig,
  appleAppStoreLink,
  appliedConfig,
  googlePlayStoreLink,
} from "../config/commonConfig";
const AboutUs = () => {
  return (
    <section
      id="about"
      className={
        "section " +
        (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "px-lg-4 "
          : " ")
      }
    >
      <div
        className={
          "container " +
          (appliedConfig.appliedIntro === IntroThemeConfig.Intro1 &&
          appliedConfig.appliedIntroContent === IntroContentConfig.Image
            ? "pt-5 "
            : " ")
        }
      >
        <div className="row">
          <div className="col-lg-12 text-center text-lg-start">
            <p>
У моєму випадку людина взялася ремонтувати автомобіль марки Порше, обговорений термін ремонту був 10 робочих днів, але автомобіль відремонтований не був, ремонт затягнувся на 2 місяці! Коли я прийшов забирати свій автомобіль, власник шахрай Коломиец Иван озвучив мені, що вартість ремонту вийшла на 2000$ дорожче, ніж було обумовлено спочатку. Докменти, що підтверджують це, він показувати відмовився, і почав погрожувати, що зніме запчастини з мого автомобіля. Я видмовився доплачувати і поки я поїхав до Одеси до юриста, він зняв з мого автомобіля фари, які із заводу стояли на автомобілі і встановив фари зі старої розбитої машини такої ж моделі. Також коли я повернувся з адвокатом, він почав нецензурно висловлюватись і кричати, що від нього вимагають безкоштовний ремонт, хоча обумовлену суму я сплатив! Добре, що я зняв момент розрахунків на відео, бо цей аферист погрожував поліцією! <br />
Через тиждень, як я забрав свій автомобіль, на панелі приладів почали спалахувати помилки, після візиту в інший автосервіс мені дали висновок, що ремонт був зроблений не якісно, а запчастини встановлені були відновленими, а саме піддавалися ремонту! <br />
Це жахливе місце та аферист власник, не зв'язуйтесь!<br />
Була адреса на Google картах, але через величезну кількість негативних відгуків його клієнтів він видалив адресу СТО та розборки на Google картах.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
